// Bootstrap PWA — composition root.
// Pas de logique metier ici. Composants en pages/, composables en features/<domain>/.

import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./app/App.vue";
import { router } from "./app/router";
import { useThemeStore } from "@/features/theme/stores/theme-store";
import "./styles/main.css";

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

// Apparence : applique data-theme="..." sur <html> avant le mount pour
// eviter un flash clair/sombre au boot.
useThemeStore(pinia).init();

app.use(router);
app.mount("#app");

// Service worker (P8.A) — production uniquement, en dev Serwist desactive.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  void navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((err: unknown) => {
    console.warn("SW register failed", err);
  });
  // Auto-reload des onglets ouverts quand un nouveau SW prend le controle
  // (skipWaiting + clientsClaim activent immediatement la nouvelle version
  // mais le code JS deja charge reste l'ancien sans reload).
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
